<template>
  <div>
    <v-list>
      <ListItem
        :title="subject.name"
        :subtitle="$t('fields.name')"
      />

      <ListItem
        v-if="subject.options"
        :title="$t(`fields.${subject.options.is_primary}`)"
        :subtitle="$t('fields.primary_school')"
      />

      <ListItem
        v-if="subject.options"
        :title="$t(`fields.${subject.options.is_secondary}`)"
        :subtitle="$t('fields.secondary_school')"
      />

      <ListItem
        v-if="subject.options"
        :title="subject.options.printOrder"
        :subtitle="$t('fields.print_order')"
      />
    </v-list>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  import ListItem from '../../shared/Lists/ListItem';

  export default {
    name: 'SubjectDetails',
    components: { ListItem },
    props: {
      subject: {
        type: Object,
        default: () => {},
      },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),
    },
  };
</script>
